import { useMutation, useQueryClient } from '@tanstack/react-query'
import { removeRequirementFromPosition } from 'api/company/position/requirement'
import { requirementDataForPositionKey } from './keys'

export type RemoveRequirementFromPositionVariables = { requirementId: number }

export const useRemoveRequirementFromPositionMutation = (
  positionId: number | null
) => {
  const queryClient = useQueryClient()
  return useMutation<void, Error, RemoveRequirementFromPositionVariables>({
    mutationFn: ({ requirementId }) => {
      if (!positionId) {
        throw new Error('Position ID is required')
      }
      return removeRequirementFromPosition(positionId, requirementId)
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: requirementDataForPositionKey(positionId),
      })
    },
  })
}
